import SvgIcon from '@mui/material/SvgIcon'
import { FITNESS_METRICS } from '../Utils/utils'

export default function FitnessRingsIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 120 120">
      {Object.entries(FITNESS_METRICS).map(([key, { colour, radius }]) => (
        <circle
          key={key}
          cx="60"
          cy="60"
          r={radius}
          fill="none"
          stroke={colour}
          strokeWidth="8"
        />
      ))}
    </SvgIcon>
  )
}
